export const IGNORE_BALE_LABELS = [
  'Bale Polygon',
  'Bale',
  'Bale ID Tag',
  'bale_strap',
  'Background',
  'Non-Target',
  'Label',
  'Loose Material',
  'Clear Mouthwash Bottle',
  'Scraps',
  'Unknown',
];

export const MODEL_FALLBACK_CATEGORIES = {
  alu: 'UBC',
  alu_loose: 'UBC',
  briquette: 'UBC',
  pet: 'PET Bottle',
};

const ALU_LABEL_GROUPS = {
  'Aluminium Food Can': ['Aluminium Food Can'],
  'Foil and Tray': ['Aluminium Foil Trays'],
  'Non Metal': [
    'Rigid Plastic',
    'Film',
    'Non Metallic',
    'Fibers & Textile',
    'Small Plastic',
    'Lighters',
    'Vapes',
    'Non-Metal',
    'WEEE',
  ],
  'Other Aluminium': ['Aluminium Bottles', 'Aluminium Caps', 'Aluminium Aerosol', 'Other Aluminium', 'Bottle cap'],
  'Other Metal': ['Other Metal', 'Steel'],
};

const INSPECTION_ALU_LABEL_GROUPS = {
  ...ALU_LABEL_GROUPS,
  'Aluminium Aerosol': ['Aluminium Aerosol'],
  'Other Aluminium': ['Aluminium Bottles', 'Aluminium Caps', 'Other Aluminium', 'Bottle cap'],
};

const PET_LABEL_GROUPS = {
  'Clear PET tray': ['Clear tray'],
  'Clear, non-food-grade': ['Clear Non-Food grade'],
  'Dark Blue': ['Dark blue'],
  Film: ['Film'],
  Green: ['Green', 'Other colour'],
  'Light Blue': ['Light blue'],
  Liquid: ['Liquids'],
  'Non Plastic': ['Non Plastic', 'Metal'],
  'Other PET Bottle': ['Very Large PET Bottle'],
  'Other Plastic': ['Other Plastic', 'Bottle cap'],
};

export const LABEL_GROUPS = {
  alu: ALU_LABEL_GROUPS,
  alu_loose: ALU_LABEL_GROUPS,
  briquette: ALU_LABEL_GROUPS,
  pet: PET_LABEL_GROUPS,
};

export const getLabelGroups = ({ showAerosols = false }: { showAerosols: boolean }) => {
  if (!showAerosols) {
    return LABEL_GROUPS;
  }

  return {
    alu: INSPECTION_ALU_LABEL_GROUPS,
    alu_loose: INSPECTION_ALU_LABEL_GROUPS,
    briquette: INSPECTION_ALU_LABEL_GROUPS,
    pet: PET_LABEL_GROUPS,
  };
};
